module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_8004.01b03c2d.png";